import React from "react";
import {useTranslation} from "react-i18next";
import {KatButton, KatDateRangePicker, KatDropdown, KatModal} from "@amzn/katal-react";
import {EventModal} from "src/components/healthDashboard/editableView/EventModal";
import {IOperation} from "src/context/models/Section";
import {IEvent} from "src/context/models/Event";

export type UpdateEventButtonProps = {
    section: string,
    operation?: string,
    event?: IEvent
};

export function UpdateEventButton(props: UpdateEventButtonProps) {
    const {section, operation, event} = props;
    const {t} = useTranslation();
    const [isEventModalVisible, setIsEventModalVisible] = React.useState(false);
    const className = operation ? "operation-update-event" : "section-update-event";

    return (
        <div className={className}>
            <KatButton
                className="update-event-button"
                variant="primary"
                label={event == undefined ? t("Create Event") : t("Update Event")}
                onClick={() => setIsEventModalVisible(!isEventModalVisible)}
            />
            {isEventModalVisible ?
                <EventModal
                    setVisible={setIsEventModalVisible}
                    section={section}
                    operation={operation}
                    event={event}
                /> : null
            }
        </div>
    );
}